
import Scene from "./scene";
import EchoDemoScene from "../../../scene/echodemo/echodemoscene";


export default class SceneService 
{
   current:Scene | null = null;
   constructor()
   {

   }

  async activate(scene_name:string,canvas:HTMLCanvasElement)
  {
    if(this.current)
    {
        this.deactivate();
    }

    if(scene_name == "echo-demo")
    {
        const scene = new EchoDemoScene();
        this.current = scene;
        await scene.activate(canvas);
    }
   
  }

   prepare(device: GPUDevice) {
    if (this.current) {
      this.current.prepare(device);
    }
  }

  deactivate()
  {
     if(this.current)
     {
        this.current.deactivate();
        this.current = null;
     }
  }

  query_number(key: string): number | null
   {
     if(this.current)
     {

       return this.current.query_number(key);
     }
    return null;
}

   query_string(key: string): string| null
      {
      if(this.current)
      {

         return this.current.query_string(key);
      }
      return null;
   }


   query_bool(key: string): boolean | null
   {
     if(this.current)
     {

       return this.current.query_bool(key);
     }
      return null;
   }

   set_string(key: string, str:string): void
   {
      console.log("scene_service",str);
     if(this.current)
     {
        this.current.set_string(key,str);
     }

   }




   ui_message(cmd:string,msg:string)
   {
      if(this.current)
      {
         this.current.ui_message(cmd,msg);
      }
   }

     tick(delta_time: number)
     {
         if (this.current) 
         {
            this.current.tick(delta_time);
         }
     }

}

